import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class LiquidityCapitalGainError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('LiquidityCapitalGainError', ...args);
    }
}
export default LiquidityCapitalGainError;
